module.exports = "<p ng-repeat=\"guestListEntry in $ctrl.data\">\r\n    <strong>{{guestListEntry.expectedArrival | date:'medium'}}</strong><br/>\r\n    <span ng-if=\"!guestListEntry.guest.isBusiness\">{{guestListEntry.guest.firstName}} {{guestListEntry.guest.middleName}} {{guestListEntry.guest.lastName}}</span>\r\n    <span ng-if=\"guestListEntry.guest.isBusiness\">{{guestListEntry.guest.business}} (Business)</span>\r\n</p>\r\n<p ng-if=\"!$ctrl.data || $ctrl.data.length == 0\">\r\n    No upcoming guests on your list\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/components/sidebar/piper-upcoming-guests-widget/piper-upcoming-guests-widget.component.html
// module id = 598
// module chunks = 0